import React, { memo } from 'react';
const Footer = () => {
  return <footer className="w-full bg-[#5E4B3C] text-white py-8" data-id="element-113">
      <div className="container mx-auto px-4" data-id="element-114">
        <div className="max-w-5xl mx-auto" data-id="element-115">
          
          <div className="border-t border-gray-600 pt-6 text-center text-sm text-gray-400" data-id="element-116">
            <p className="mb-2" data-id="element-117">
              © {new Date().getFullYear()} Combo Gourmet. Todos los
              derechos reservados.
            </p>
            <p data-id="element-118">
              Los resultados pueden variar. Las imágenes son solo ilustrativas.
            </p>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;